import { useQuery } from "react-query";
import { gql } from "graphql-request";
import { usePbm2Url } from "@common/hooks/usePbm2Url";
import { IBiReport } from "../contracts";

export function useEmbedUrl() {
  const programId = "DPSP";
  const { request } = usePbm2Url();
  return useQuery(`dashboards`, async () => {
    const {
      Dashboards_biReports: { edges },
    } = await request(
      gql`
        query ($filter: Dashboards_BiReportArgsFilterInput) {
          Dashboards_biReports(filter: $filter) {
            edges {
              node {
                id
                embedUrl
              }
            }
          }
        }
      `,
      { filter: { programId } }
    );

    return (
      (edges || []).map(({ node }: { node: IBiReport }) => node) as IBiReport[]
    )[0];
  });
}
